module.exports = __webpack_public_path__ + "img/trefle_grey.90bf4df0.png";